"use client";
import React from "react";
import { useFormContext } from "react-hook-form";
import { EventBySlugOutput } from "~/types/EventTypesInferred";
import { EventPreview } from "~/components/v3/events-components/EventPreview";
import { ApplyToSponsorFormData } from "./types";
import { GetSponsorPackageForEvent } from "../actions";
import { sponsorPlanColors, SponsorTierCard } from "./SponsorTierCard";

type Props = {
    event: EventBySlugOutput;
    sponsorshipPackage?: GetSponsorPackageForEvent;
};

export const SponsorStep1 = React.memo(
    ({ event, sponsorshipPackage }: Props) => {
        const { watch, setValue } = useFormContext<ApplyToSponsorFormData>();
        const selectedTier = watch("selectedPackageTier");

        const handleSelectTier = (tierId: string) => {
            const selected = sponsorshipPackage?.packageTiers.find(
                (tier) => tier.id === tierId,
            );
            if (!selected) return;
            setValue("selectedPackageTier", selected);
        };

        return (
            <div className="flex flex-col bg-black text-white">
                <div className="p-4 sm:p-6 md:p-8">
                    <p className="text-sm text-v3-N300">APPLY TO SPONSOR</p>
                    <h4 className="text-xl font-bold sm:text-2xl">
                        Step 1: Choose a plan below for selected event
                    </h4>
                    <EventPreview event={event} />
                </div>
                <div className="pt-0 sm:p-6 md:p-8">
                    <h4 className="text-lg font-bold sm:text-xl">
                        Choose from
                    </h4>
                    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3">
                        {sponsorshipPackage?.packageTiers.map((tier, index) => (
                            <SponsorTierCard
                                key={tier.id}
                                tier={tier}
                                asset={sponsorshipPackage.asset}
                                communitySlug={event.community?.slug}
                                color={
                                    sponsorPlanColors[
                                        index % sponsorPlanColors.length
                                    ] ?? "black"
                                }
                                isSelected={selectedTier?.id === tier.id}
                                onSelect={handleSelectTier}
                            />
                        ))}
                    </div>
                </div>
            </div>
        );
    },
);

SponsorStep1.displayName = "SponsorStep1";
